var FileWrapper = require('filewrapper');
var Session = require('session');
var Connection = require('connection');
var Org = require('org');
var uriTemplates = require('uri-templates');

var Avatar = FileWrapper.extend({
    triggerBubble: function () {
        var args = _.toArray(arguments);
        // Prefix event name
        var event = 'avatar-' + args.shift();
        args.unshift(event);
        this.trigger.apply(this, args);
        // Send this as second arg
        args.shift();
        args.unshift(event, this);
        this.session.trigger.apply(this.session, args);
    },
    getTemplateUri: function () {
        return Avatar.TEMPLATE_URI;
    },
    getTemplateUriParams: function () {
        return this.getBaseTemplateUriParams();
    },
    uploadPath: function () {
        return this.session.backend.buildRawUrl(Avatar.UPLOAD_PATH);
    },
    matchesModel: function (model) {
        if (model instanceof Session) {
            return this.isPrimary();
        } else if (model instanceof Org) {
            return this.get('org') == model.id;
        } else if (model instanceof Connection) {
            return this.get('cid') == model.id;
        } else {
            return false;
        }
    },
    isPrimary: function () {
        return this.get('is_primary');
    },
    finaliseParams: function () {
        var params = FileWrapper.prototype.finaliseParams.call(this);
        params.type = 'avatar';
        if (this.isPrimary()) {
            params.primary = "1";
        }
        params.cid = this.get('cid');
        params.org = this.get('org');
        return params;
    },
    getCachedSquareUrl: function (width) {
        return FileWrapper.cachedDataUrl(this.id) || this.getSquareUrl(width);
    },
    isAcceptableType: function () {
        return Avatar.isAcceptableType(this.getType());
    }
}, {
    UPLOAD_PATH: '/chat/upload-avatar',
    TEMPLATE_URI: window.IRCConfig.avatar_uri_template,
    REDIRECT_TEMPLATE_URI: window.IRCConfig.avatar_redirect_uri_template,
    fromFile: function (file, session) {
        return FileWrapper.fromFile(file, session, Avatar);
    },
    isAcceptableType: function (type) {
        return type === 'image/png'
            || type === 'image/gif'
            || type === 'image/jpeg';
    },
    isExternalSecure: function (avatar) {
        return !!avatar.match(/^https:\/\/.+/);
    },
    redirectTemplate: function (uid, modifiers) {
        var data = {
            id: uid
        };
        if (modifiers !== '') {
            data.modifiers = modifiers || 's{size}';
        }
        return decodeURIComponent(uriTemplates(Avatar.REDIRECT_TEMPLATE_URI).fill(data));
    },
    idToTemplate: function (avatarId) {
        return decodeURIComponent(uriTemplates(Avatar.TEMPLATE_URI).fill({
            modifiers: 's{size}',
            id: avatarId
        }));
    }
});

module.exports = Avatar;



//////////////////
// WEBPACK FOOTER
// ./app/src/model/avatar.js
// module id = lKP6
// module chunks = 1